import React, { useEffect, useMemo, useState } from 'react';
import api from '../../config/axios';
import './AddItemsModal.css';

interface MenuItem { _id: string; name: string; price: number; imageUrl: string; category: string; }

interface Props {
  orderId: string;
  onClose: () => void;
  onAdded: () => void; // gọi sau khi thêm thành công (để refresh)
}

// Chọn thêm món vào một đơn chưa thanh toán. Dùng chung cho màn Đơn hàng & Bàn.
const AddItemsModal: React.FC<Props> = ({ orderId, onClose, onAdded }) => {
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [qty, setQty] = useState<Record<string, number>>({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/api/menu').then((r) => setMenus(r.data.data)).catch(() => setError('Không tải được thực đơn'));
  }, []);

  const inc = (id: string) => setQty((q) => ({ ...q, [id]: (q[id] || 0) + 1 }));
  const dec = (id: string) => setQty((q) => ({ ...q, [id]: Math.max(0, (q[id] || 0) - 1) }));
  const chosen = useMemo(() => menus.filter((m) => (qty[m._id] || 0) > 0), [menus, qty]);
  const totalQty = chosen.reduce((s, m) => s + (qty[m._id] || 0), 0);

  const submit = async () => {
    if (chosen.length === 0) return;
    setSaving(true);
    setError('');
    try {
      const items = chosen.map((m) => ({ menuId: m._id, name: m.name, price: m.price, quantity: qty[m._id], imageUrl: m.imageUrl }));
      await api.post(`/api/orders/${orderId}/items`, { items });
      onAdded();
      onClose();
    } catch (e: any) {
      setError(e.response?.data?.message || 'Lỗi thêm món');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="add-items-bg" onClick={onClose}>
      <div className="add-items-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Thêm món vào đơn</h3>
        {error && <div className="add-items-error">{error}</div>}
        <div className="add-items-grid">
          {menus.map((m) => (
            <div className="add-items-card" key={m._id}>
              <img src={m.imageUrl} alt={m.name} />
              <div className="add-items-name">{m.name}</div>
              <div className="add-items-price">{m.price.toLocaleString()} đ</div>
              <div className="add-items-stepper">
                <button type="button" onClick={() => dec(m._id)}>−</button>
                <span>{qty[m._id] || 0}</span>
                <button type="button" onClick={() => inc(m._id)}>+</button>
              </div>
            </div>
          ))}
        </div>
        <div className="add-items-actions">
          <button className="add-items-cancel" onClick={onClose}>Huỷ</button>
          <button className="add-items-save" disabled={saving || totalQty === 0} onClick={submit}>
            {saving ? 'Đang thêm...' : `Thêm ${totalQty} món`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddItemsModal;
